import { initializeApp } from 'firebase/app';
import {
  // sendEmailVerification,
  // fetchSignInMethodsForEmail,
  createUserWithEmailAndPassword,
  FacebookAuthProvider,
  getAuth,
  getRedirectResult,
  GoogleAuthProvider,
  // onAuthStateChanged,
  // signInWithPopup,
  // GoogleAuthProvider,
  // FacebookAuthProvider,
  isSignInWithEmailLink,
  sendSignInLinkToEmail,
  signInAnonymously,
  signInWithEmailAndPassword,
  signInWithEmailLink,
  // signOut,
  // RecaptchaVerifier,
  // signInWithPhoneNumber,
  // PhoneAuthProvider,
  // linkWithPhoneNumber,
  // unlink,
  signInWithRedirect,
} from 'firebase/auth';
import React from 'react';
import mixpanel from 'utils/mixpanelConfig';

import {
  updateDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  getFirestore,
  setDoc,
} from 'firebase/firestore';

import api from 'utils/api';
import { firebaseConfig } from 'utils/configs';

const { createContext, useContext, useState, useEffect, useCallback } = React;

const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);

export const db = getFirestore(firebaseApp);

export const FirebaseAuthContext = createContext({});
FirebaseAuthContext.displayName = 'FirebaseAuth';

export const FirebaseAuthProvider = (props) => {
  const { children } = props;

  const [currentUser, setCurrentUser] = useState(null);
  const [anonymousCurrentUser, setAnonymousCurrentUser] = useState(null);

  const [isSignIn, setIsSignIn] = useState(null);
  const [loading, setLoading] = useState(true);
  const [global, setGlobal] = useState({});
  const getUser = () => {
    return auth.currentUser;
  };

  const reloadUser = async () => {
    if (auth.currentUser) {
      await auth.currentUser.reload();
      if (auth.currentUser.isAnonymous) {
        setAnonymousCurrentUser(auth.currentUser);
      } else {
        setCurrentUser(auth.currentUser);
      }
    }
  };

  const signOut = async () => {
    await auth.signOut();
    mixpanel.reset();
  };

  const emailSignUp = (email, password) => {
    return createUserWithEmailAndPassword(auth, email, password);
  };

  const emailSignIn = (email, password) => {
    return signInWithEmailAndPassword(auth, email, password);
  };

  const isEmailLink = () => {
    return isSignInWithEmailLink(auth, window.location.href);
  };

  const emailLinkSignIn = (email) => {
    return signInWithEmailLink(auth, email, window.location.href);
  };

  const verifyEmailAddress = () => {
    return api.request({
      url: `/api/v2/sendEmailVerification`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${auth.currentUser.accessToken}`,
      },
      data: {
        redirectUrl: `${window.location.origin}`,
      },
    });
  };

  const sendEmailSignInLink = (email) => {
    return sendSignInLinkToEmail(auth, email, {
      url: `${window.location.origin}/email`,
      handleCodeInApp: true,
    });
  };

  const googleSignIn = () => {
    const provider = new GoogleAuthProvider();
    return auth.signInWithPopup(provider);
  };

  const fbSignIn = () => {
    const provider = new FacebookAuthProvider();
    return auth.signInWithPopup(provider);
  };

  const googleSignInWithRedirect = () => {
    const provider = new GoogleAuthProvider();
    return signInWithRedirect(auth, provider); //auth.signInWithPopup(provider);
  };

  const facebookSignInWithRedirect = () => {
    const provider = new FacebookAuthProvider();
    return signInWithRedirect(auth, provider);
  };

  const handleRedirect = () => {
    return getRedirectResult(auth);
  };

  const anonymousSignIn = () => {
    return signInAnonymously(auth);
  };

  useEffect(() => {
    try {
      const collectionRef = collection(db, 'global');
      getDocs(collectionRef).then((snapshot) => {
        const globalData = {};
        snapshot.forEach((doc) => {
          globalData[doc.id] = doc.data();
        });
        setGlobal((prev) => {
          return { ...prev, ...globalData };
        });
      });
    } catch (error) {
      console.log(error);
    }
    return () => {};
  }, []);

  useEffect(() => {
    let unsubscribe;
    if (auth) {
      unsubscribe = auth.onAuthStateChanged(async (authUser) => {
        if (authUser && authUser.isAnonymous) {
          setCurrentUser(null);
          setAnonymousCurrentUser(authUser);
        } else if (authUser) {
          setCurrentUser(authUser);
          setAnonymousCurrentUser(null);
        } else {
          setCurrentUser(null);
          setAnonymousCurrentUser(null);
        }
        setIsSignIn(authUser ? true : false);
        setLoading(false);
        if (authUser) {
          const sub = authUser.uid;
          try {
            const collectionRef = collection(db, 'users');
            const userDoc = await getDoc(doc(collectionRef, sub));
            if (userDoc.exists()) {
              const docData = userDoc.data();
              if (docData.productCollection === undefined) {
                await updateDoc(doc(db, 'users', sub), {
                  productCollection: [],
                });
              }
            } else {
              // init firestore user doc
              await setDoc(doc(db, 'users', sub), {
                uid: sub,
                email: authUser.email,
                productCollection: [],
              });
            }
          } catch (error) {
            console.log(error);
          }
        }
      });
    }
    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, []);

  return (
    <FirebaseAuthContext.Provider
      value={{
        auth,
        currentUser,
        anonymousCurrentUser,
        loading,
        isSignIn,
        global,
        getUser,
        reloadUser,
        emailSignIn,
        emailSignUp,
        verifyEmailAddress,
        sendEmailSignInLink,
        isEmailLink,
        emailLinkSignIn,
        googleSignIn,
        fbSignIn,
        signOut,
        googleSignInWithRedirect,
        facebookSignInWithRedirect,
        handleRedirect,
        anonymousSignIn,
      }}
    >
      {children}
    </FirebaseAuthContext.Provider>
  );
};

export const useFirebaseAuth = () => {
  return useContext(FirebaseAuthContext);
};
